// Visual source of truth: docs/specs/2026-09-28-tooltip-figma-rework.md
// ("Shortcut" and "key chip"). Colors, radius, shadow and glyph sizes are
// registry tokens; the chip size is Figma keycap geometry.

@layer base-components {
    .shortcut {
        // ds-deviation: keycap dimension, no size token family.
        --shortcut-key-size: 20px;

        display: inline-flex;
        align-items: center;
        gap: var(--space-4);
    }

    .sm {
        // ds-deviation: keycap dimension, no size token family.
        --shortcut-key-size: 16px;
    }

    .chord {
        display: inline-flex;
        align-items: center;
        gap: var(--space-2);
    }

    .then {
        font-family: var(--font-family-base);
        font-size: var(--font-size-11);
        font-weight: var(--font-weight-400);
        line-height: 1;
        letter-spacing: var(--tracking-base);
        color: var(--fg-secondary);
        white-space: nowrap;
    }

    .key {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        box-sizing: border-box;
        width: var(--shortcut-key-size);
        height: var(--shortcut-key-size);

        // Resets Bootstrap's global `kbd` padding and font size.
        padding: 0;
        font-size: var(--font-size-2xs);

        background: var(--bg-primary);
        border: var(--border-width) solid var(--border-default);
        box-shadow: var(--shadow-1);
        border-radius: var(--radius-xs);
        color: var(--fg-secondary);

        font-family: var(--font-family-base);
        font-weight: var(--font-weight-400);
        line-height: 1;
        letter-spacing: var(--tracking-base);

        // ds-deviation: every glyph SVG is drawn on a 10px canvas; no icon size
        // token covers it. Two classes so hosts that size every descendant svg
        // (Button's `.md svg`) cannot resize the glyph, whatever the load order.
        > .glyph {
            flex-shrink: 0;
            width: 10px;
            height: 10px;
        }

        // The chip fades with a disabled button's muted label.
        button:disabled & {
            color: var(--fg-disabled);
            box-shadow: none;
        }
    }

    .letter {
        font-size: var(--font-size-2xs);
    }

    .text {
        width: auto;
        min-width: var(--shortcut-key-size);
        padding-inline: var(--space-4);
        font-size: var(--font-size-2xs);
        font-weight: var(--font-weight-500);
        white-space: nowrap;
    }

    .symbol {
        font-size: var(--font-size-11);
    }

    .equal {
        font-size: var(--font-size-xs);
    }

    .arrowLeft {
        transform: rotate(90deg);
    }

    .arrowUp {
        transform: rotate(180deg);
    }

    .arrowRight {
        transform: rotate(-90deg);
    }
}
